import { MarkdownRenderer, MarkdownRendererProps } from "./MarkdownRenderer";

export interface NuclinoMarkdownRendererProps extends MarkdownRendererProps {}

export function MarkdownRendererForNuclino({
  config = {
    isSkipHtml: true, // Nuclino MD content includes HTML like comments, <br/>, etc.
    gfm: true,
  },
  isUseDefaultMargins = true,
  ...otherProps
}: NuclinoMarkdownRendererProps) {
  return (
    <MarkdownRenderer
      config={config}
      isUseDefaultMargins={isUseDefaultMargins}
      componentProps={{
        p: {
          sx: { fontSize: "16px" },
        },
      }}
      {...otherProps}
    />
  );
}
